import MutualAid from './mutualAid';

export { MutualAid };
